// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__KxaTv","upload":"Small_upload__1cU9N","imageWrap":"Small_imageWrap__2a8cU","removeBtn":"Small_removeBtn__2s1Ro"};